module.exports = __webpack_public_path__ + "bh.64fbbb84a291b85f3059.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bh.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bh.svg
// module chunks = styles